import React from 'react';
import founder from '../../images/founder.jpg';
import { Container, Grid, Typography, Box } from '@mui/material';
import { SecondaryButton } from '../Button';
import Infotip from '../Tooltip';
import { founderBody } from '../../content/about';

interface Props {
  expanded: boolean;
  onToggle: () => void;
}

const Founder = ({ expanded, onToggle }: Props) => {
  const paragraphs = expanded ? founderBody : [founderBody[0]];

  return (
    <Container sx={{ mt: 4, display: 'flex', justifyContent: 'center' }} maxWidth={false}>
      <Grid container spacing={3} id="founder" sx={{ maxWidth: { sm: '95%', md: 1000, lg: 1200 }, width: '100%' }} alignItems='center' display='flex' justifyContent='center'>
        <Grid size={{ xs: 12, lg: 5 }}>
          <Box component="img" src={founder} alt='founder-image' data-testid="about-founder-image" sx={{ width: '100%', height: 'auto', borderRadius: '10%' }} />
        </Grid>
        <Grid size={{ xs: 12, lg: 7 }} sx={{ pl: { lg: 3 } }}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography component="h2" data-testid="about-founder-title" gutterBottom fontSize={{ md: '2rem', xl: '3rem' }} sx={{ textAlign: 'center' }}>
              iet'ene ka{' '}
              <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                mang
                <Infotip title="Meaning: Who founded iets'ene?"/>
              </Box>
            </Typography>
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              {paragraphs.map((text, i) => (
                <Typography key={i} variant='body1' fontSize={{ md: '1.4rem', xl: '2rem' }} gutterBottom>
                  {text}
                </Typography>
              ))}
            </Box>
            <SecondaryButton
              sx={{ fontSize: { md: '1rem', xl: '2rem' }, mt: 2 }}
              onClick={onToggle}
            >
              {expanded ? 'Show less' : 'Read more'}
            </SecondaryButton>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Founder;